var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 93,
    viewBox: "0 0 71 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5220",
    "data-name": "Group 5220",
    transform: "translate(-1282.484 -2138.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4347",
    "data-name": "Group 4347",
    transform: "translate(1282.984 2138.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M384.225,217.992l-18.133,12.627V205.37Z",
    transform: "translate(-340.045 -185.592)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M329.942,290.3",
    transform: "translate(-319.922 -232.868)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2678",
    "data-name": "Rectangle 2678",
    width: 5.945,
    height: 1.933,
    transform: "translate(4.074 3.644)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2679",
    "data-name": "Rectangle 2679",
    width: 5.945,
    height: 1.933,
    transform: "translate(14.422 3.644)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2680",
    "data-name": "Rectangle 2680",
    width: 5.945,
    height: 1.933,
    transform: "translate(24.77 3.644)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2681",
    "data-name": "Rectangle 2681",
    width: 5.941,
    height: 1.933,
    transform: "translate(35.118 3.644)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2682",
    "data-name": "Rectangle 2682",
    width: 5.945,
    height: 1.933,
    transform: "translate(45.462 3.644)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2683",
    "data-name": "Rectangle 2683",
    width: 5.945,
    height: 1.933,
    transform: "translate(55.809 3.644)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M307.342,186.84v40.789h66.016V186.84Zm64.242,39.015H309.115V188.613h62.469Z",
    transform: "translate(-307.342 -175.277)",
    fill: "#313830",
    stroke: "#313830",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5729",
    "data-name": "Path 5729",
    d: "M307.342,160.76v9.222h66.016V160.76Zm64.242,7.448H309.115v-5.675h62.469Z",
    transform: "translate(-307.342 -160.76)",
    fill: "#313830",
    stroke: "#313830",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2684",
    "data-name": "Rectangle 2684",
    width: 5.945,
    height: 1.933,
    transform: "translate(4.074 57.893)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2685",
    "data-name": "Rectangle 2685",
    width: 5.945,
    height: 1.933,
    transform: "translate(14.422 57.893)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    width: 5.945,
    height: 1.933,
    transform: "translate(24.77 57.893)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    width: 5.941,
    height: 1.933,
    transform: "translate(35.118 57.893)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 5.945,
    height: 1.933,
    transform: "translate(45.462 57.893)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 5.945,
    height: 1.933,
    transform: "translate(55.809 57.893)",
    fill: "#313830",
    stroke: "#313830",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M307.342,283.12v9.222h66.016V283.12Zm64.242,7.448H309.115v-5.675h62.469Z",
    transform: "translate(-307.342 -228.871)",
    fill: "#313830",
    stroke: "#313830",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.b6f04f3e7eeb097bb9edfa4cf7d6d6fe.svg";
export { ForwardRef as ReactComponent };